import { DropdownOptionType } from "./dropdown-types";

export const removeConsecutiveDividers = (
  arr: DropdownOptionType[],
): DropdownOptionType[] => {
  return arr
    .filter((item, index) => {
      if (item.type !== "divider") return true;
      const prev = arr[index - 1];
      return prev && prev.type !== "divider";
    })
    .filter(
      (item, index, filtered) =>
        item.type !== "divider" || index < filtered.length - 1,
    );
};
